module.exports = __webpack_public_path__ + "static/mavillesurlenet-4192432a97365fd557dbd2f7161adeaa.png";